import { BaseComponent, BaseComponentAttrs } from "../base/baseComponent";
import { CompType } from "../base/baseEnum";

/** 获奖组件属性接口 */
export type CompetitionAttrs = BaseComponentAttrs;

/** 获奖组件类 */
export class CompetitionComponent extends BaseComponent<CompetitionAttrs> {
  constructor(data: Partial<BaseComponent<CompetitionAttrs>> = {}) {
    super(data);
    this.type = CompType.competition;
  }
  /** 获取标题 */
  public getTitle(): string {
    return this.title || "";
  }
}
